var map = {
	"./boxer.png": 6797,
	"./delivery.svg": 1275,
	"./hero-video.webm": 5747,
	"./highlight-stroke.svg": 5618,
	"./iveco.png": 9755,
	"./jumper.png": 6002,
	"./kombij-logo-6kb.png": 1047,
	"./logo.png": 2806,
	"./master.png": 9713,
	"./movano.png": 2881,
	"./person_with_laptop.svg": 6386,
	"./simple-logo.png": 4005,
	"./vans/boxer.png": 694,
	"./vans/iveco.png": 1860,
	"./vans/jumper.png": 2739,
	"./vans/master.png": 2588,
	"./vans/movano.png": 8920,
	"./vans/vito.png": 6765,
	"./vito.png": 4867,
	"./woman_lying.svg": 1946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;